module.exports = __webpack_public_path__ + "img/paper_negative.99d8fd93.svg";